export class Operator {
  constructor(
    public readonly id: string,
    public readonly name: string
  ) {
  }
}
